import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export function PointsLevelsInfoDialog() {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          className="p-1 hover:bg-gray-100 transition rounded-md"
          type="button"
          aria-label="How to get points"
        >
          <Info className="w-4 h-4 text-blue-500" />
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg w-full">
        <DialogHeader>
          <DialogTitle>{t("community.pointsLevelsInfoDialog.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="text-gray-700 space-y-3 text-sm">
            <div>
              <span className="font-semibold">
                {t("community.pointsLevelsInfoDialog.pointsTitle")}
              </span>
              <br />
              {t("community.pointsLevelsInfoDialog.pointsDesc")}
            </div>
            <div>
              <span className="font-semibold">{t("community.pointsLevelsInfoDialog.levelsTitle")}</span>
              <br />
              {t("community.pointsLevelsInfoDialog.levelsDesc")}
            </div>
            <ul className="mt-2 grid grid-cols-2 gap-x-6 text-sm">
              <li>{t("community.pointsLevelsInfoDialog.levelsList.1")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.2")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.3")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.4")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.5")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.6")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.7")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.8")}</li>
              <li>{t("community.pointsLevelsInfoDialog.levelsList.9")}</li>
            </ul>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
